<template>
    <el-footer class="tw-footer" :style="style">
        <slot></slot>
    </el-footer>
</template>

<script>
import { computed } from 'vue'

export default {
    name: 'tw-footer',
    props: {
        height: {
            type: String,
            default: null,
        },
    },
    setup(props) {
        return {
        style: computed(
            () =>
            (props.height
                ? {
                    '--tw-footer-height': props.height,
                }
                : {})
        ),
        }
    },
}
</script>

<style>

</style>